import Vue from 'vue'
import Router from 'vue-router'
import CtEntreprise from '@/components/CtEntreprise'
import CtRealisations from '@/components/CtRealisations'
import CtContact from '@/components/CtContact'
import CtRealisation from '@/components/CtRealisation'
import CtMentions from '@/components/CtMentions'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			redirect: '/entreprise',
		},
		{
			path: '/entreprise',
			name: 'Entreprise',
			component: CtEntreprise
		},
		{
			path: '/realisations',
			name: 'Realisations',
			component: CtRealisations
		},
		{
			path: '/realisations/:id',
			name: 'Realisation',
			component: CtRealisation
		},
		{
			path: '/contact',
			name: 'Contact',
			component: CtContact
		},
		{
			path: '/mentions',
			name: 'Mentions',
			component: CtMentions
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js